export const LEGAL_FACE_H5 = 'https://brain.baidu.com/face/print/';
export const HOST_CONFIG = {
    online: 'https://console.bce.baidu.com',
    localhost: 'https://localhost.qasandbox.bcetest.baidu.com:8100',
    sandbox: 'https://qasandbox.bcetest.baidu.com',
};
